module.exports = __webpack_public_path__ + "img/plus-circle.685bb6ef.svg";